export default __webpack_public_path__ + "media/images/features/toyono/cspfc_logo-1dd6fe49823f80536490be9f94f63938.png";